class LayoutTemplateProductSearchModalController extends AbstractController
	@register()
	@inject 'ProductRepository',
		'BACKEND_PRODUCT_ENTITY_TYPE'

	search: (query) ->
		return @ProductRepository.getEntities(query, true)

	onBeforeSearch: (query, term) ->
		query.criteria 'active', '=', true
		query.criteria 'entity_type', '!=', @BACKEND_PRODUCT_ENTITY_TYPE.ADDON
			.and 'entity_type', '!=', @BACKEND_PRODUCT_ENTITY_TYPE.SHIPPING

		query.with 'product_categories'
